import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from "@angular/core";
import { GraphComponent, GraphOverviewComponent } from "@yfiles/yfiles";
import { Linqset } from "../../common/linqset-model";

// a small view of the whole model; drag the blue rectangle to move around the main canvas
@Component({
    selector: 'app-overview',
    templateUrl: 'overview.html',
    styleUrls: ['overview.css'],
    standalone: false
})
export class LinqOverviewComponent implements AfterViewInit, OnChanges, OnDestroy {
    @Input() linqset: Linqset
    @Input() graphComponent: GraphComponent

    @ViewChild('overviewComponent') overviewComponentRef: ElementRef | undefined

    overviewComponent: GraphOverviewComponent

    // created once its element exists; afterwards it is pointed at whichever graph is current
    ngAfterViewInit(): void {
        if (!this.overviewComponentRef) return
        this.overviewComponent = new GraphOverviewComponent(this.overviewComponentRef.nativeElement, this.graphComponent)
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.overviewComponent) return
        if (changes["graphComponent"] && this.overviewComponent.graphComponent !== this.graphComponent) {
            this.overviewComponent.graphComponent = this.graphComponent
        }
    }

    // the overview listens to the main canvas, so stop when the panel closes
    ngOnDestroy(): void {
        this.overviewComponent?.cleanUp()
        this.overviewComponent = undefined
    }
}
